$(function() {
  // $('.newsletter-popup').addClass('active');
  var newsletter_popup_texts = general.decodeLocale(window.kef.newsletter_popup.texts),
      newsletter_popup_show_duration = window.kef.newsletter_popup.show_duration * 1000,
      newsletter_popup_hide_duration = window.kef.newsletter_popup.hide_duration;

  var newsletter_popup_name = 'newsletter_popup',
      newsletter_popup_cookie = Cookies.get(newsletter_popup_name);

  var newsletter_popup_success_name = 'newsletter_popup_success',
      newsletter_popup_success_cookie = Cookies.get(newsletter_popup_success_name);

  if (window.location.href.indexOf('&form_type=customer#newsletter-popup-form') >= 0) {
    // validation error
    $('.newsletter-popup').addClass('active');
    if ($('.newsletter-popup .errors').length == 0) {
      var email_exist_el = `<div class="errors"><ul><li>${newsletter_popup_texts.error.email_exist}</li></ul></div>`;
      $(email_exist_el).insertAfter('.newsletter-popup-homepage .newsletter-popup-box-content-text');
      $(email_exist_el).insertAfter('.newsletter-popup-page .newsletter-griditem-form');
    }

    $('body').trigger({
      type: 'newsletter_popup_show',
      datalayer_name: 'view_welcome_pop_up_banner',
      datalayer_parameter: {
        page_name: ''
      },
    });
  } else if (window.location.href.indexOf('?customer_posted=true#newsletter-popup-form') >= 0 && typeof newsletter_popup_success_cookie === 'undefined') {
    // success
    $('.newsletter-popup').addClass('active');

    Cookies.set(newsletter_popup_name, Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), {
      expires: newsletter_popup_hide_duration
    });
    Cookies.set(newsletter_popup_success_name, Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), {
      expires: newsletter_popup_hide_duration
    });
  } else if (typeof newsletter_popup_cookie === 'undefined') {
    // hide
    setTimeout(function() {
      $('.newsletter-popup').addClass('active');

      Cookies.set(newsletter_popup_name, Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15), {
        expires: newsletter_popup_hide_duration
      });

      $('body').trigger({
        type: 'newsletter_popup_show',
        datalayer_name: 'view_welcome_pop_up_banner',
        datalayer_parameter: {
          page_name: ''
        },
      });
    }, newsletter_popup_show_duration);
  } else {
    // $('.newsletter-popup').remove();
  }
  
  $('.newsletter-popup-close').on('click', function() {
    // $('.newsletter-popup').remove();
    $('.newsletter-popup').removeClass('active');

    var click_location = $(this).get(0).nodeName == 'BUTTON' ? 'close icon' : 'pass button';
    if ($(this).parents('.newsletter-popup').find('.newsletter-popup-after').length == 0) {
      $('body').trigger({
        type: 'newsletter_popup_close',
        datalayer_name: 'close_welcome_pop_up_banner',
        datalayer_parameter: {
          click_location: click_location,
          click_page: ''
        },
      });
    }
  });
  $('body').on('click', function(e) {
    var _t = $(e.target),
        popup_box = _t.parents('.newsletter-popup-box'),
        popup = _t.parents('.newsletter-popup');
    if (popup_box.length == 1) {
    } else if (popup.hasClass('active')) {
      // $('.newsletter-popup').remove();
      $('.newsletter-popup').removeClass('active');

      var click_location = 'grey area';
      if ($('.newsletter-popup.active').find('.newsletter-popup-after').length == 0) {
        $('body').trigger({
          type: 'newsletter_popup_close',
          datalayer_name: 'close_welcome_pop_up_banner',
          datalayer_parameter: {
            click_location: click_location,
            click_page: ''
          },
        });
      }
    }
  });
  $('.newsletter-popup').on('click', 'a[href*="/pages/"]', function() {
    var href = $(this).attr('href');
    var url_obj = new URL(href, window.location.origin);
    var record_id = url_obj.pathname.split('/').slice(-1)[0];

    var click_location = 'Welcome Pop-up banner';
    // if ($('.newsletter-popup.active').find('.newsletter-popup-after').length == 1) {
    //   click_location += ' - thank you page';
    // }

    $('body').trigger({
      type: 'newsletter_popup_page_link',
      datalayer_name: 'click_info_page_link',
      datalayer_parameter: {
        'page_name': record_id,
        'click_location': click_location,
        'click_page': ''
      },
    });
  }).on('click', `a[href*="${window.kef.sso.url}/auth/signup_with_email"], a[href*="${window.kef.sso.url_alt}/auth/signup_with_email"]`, function(e) {
    var click_location = 'Welcome Pop-up banner';
    // if ($('.newsletter-popup.active').find('.newsletter-popup-after').length == 1) {
    //   click_location += ' - thank you page';
    // }

    $('body').trigger({
      type: 'newsletter_popup_sso_link',
      datalayer_name: 'click_sign_up_link', 
      datalayer_parameter: {
        'click_location': click_location,
        'click_page': ''
      },
    })
  }).on('click', 'button[type="submit"]', function() {
    var click_location = 'Welcome Pop-up banner';

    $('body').trigger({
      type: 'newsletter_popup_submit',
      datalayer_name: 'click_claim_discount',
      datalayer_parameter: {
        'click_location': click_location,
        'click_page': ''
      },
    });
  });
});